import { render, staticRenderFns } from "./VideoScale.vue?vue&type=template&id=288fac02&scoped=true"
import script from "./VideoScale.vue?vue&type=script&lang=js"
export * from "./VideoScale.vue?vue&type=script&lang=js"
import style0 from "./VideoScale.vue?vue&type=style&index=0&id=288fac02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288fac02",
  null
  
)

export default component.exports